import type { IconData } from '@stacksjs/iconify-core'

export const language: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M320 24H16v304h176v168h304V192H320ZM148.305 96L98.093 239.3H132l8.166-23.3H192v80H48V56h240v136h-66.668L187.7 96Zm36.317 88h-33.244L168 136.562ZM464 224v240H224V224Z\"/><path fill=\"currentColor\" d=\"M317.432 368.48a137 137 0 0 0 10.089 14.12q-17.4 9.384-39.521 9.4v32c24.141 0 45.71-6.408 64-18.824C370.29 417.592 391.859 424 416 424v-32q-22.075 0-39.52-9.407a137 137 0 0 0 10.088-14.113A166.2 166.2 0 0 0 406.662 320H424v-32h-56v-24h-32v24h-56v32h17.338a166.2 166.2 0 0 0 20.094 48.48M373.53 320a133 133 0 0 1-14.1 31.52a104 104 0 0 1-7.43 10.448a104 104 0 0 1-6.93-9.651A132.4 132.4 0 0 1 330.466 320Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default language
